export { default } from './withLocalTheme'
